export default {
  APP_NAME: 'Jarvison',
}
